import React from 'react';
import { useAuth } from "@/hooks/use-auth";
import { PricingCard } from "@/components/PricingCard";
import { getVisiblePlans, Plan } from "@shared/plans";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from '@/components/DashboardLayout';
import { Badge } from '@/components/ui/badge';

const PricingPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const plans = getVisiblePlans();
  const currentPlanCode = user?.planCode || "FREE";

  const handleSelectPlan = (planCode: string, interval: "month" | "annual") => {
    navigate(`/checkout?plan=${planCode}&interval=${interval}`);
  };

  return (
    <DashboardLayout>
      <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Choose Your Plan</h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Flexible pricing to fit your needs. Upgrade, downgrade, or cancel anytime.
          </p>
          {user && (
            <div className="mt-4">
              <Badge variant="secondary" className="text-base px-4 py-2">
                Your Current Plan: {currentPlanCode}
              </Badge>
            </div>
          )}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {plans.map((plan: Plan) => (
            <PricingCard
              key={plan.code}
              plan={plan}
              isCurrentPlan={currentPlanCode === plan.code}
              onSelectPlan={(interval) => handleSelectPlan(plan.code, interval)}
            />
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PricingPage;
